module.exports = __webpack_public_path__ + "static/johs-martens-news-87da2cae2e108f6411471e8b42e1bc48.png";